import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = { key: 0 }

import { toRefs, computed, CSSProperties } from 'vue'
import SvgDisplay from './SvgDisplay.vue'
import TextBase from './TextBase.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'BadgeSquare',
  props: {
    badgeText: {},
    customColor: { default: undefined },
    grey: { type: Boolean, default: false },
    hasLeftIcon: { type: Boolean, default: false },
    hasRightIcon: { type: Boolean, default: false },
    primary: { type: Boolean, default: true },
    secondary: { type: Boolean, default: false },
    size: { default: 'medium' },
    tabIndex: { default: -1 },
    containerStyle: { default: undefined }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "16080b50": (customColorProp.value)
}))

const props = __props
const { badgeText, size } = toRefs(props)

const badgeClassesText = computed(() => {
  if (size.value === 'medium') return 'badge-square__text'
  if (size.value === 'small') return 'badge-square__text__small'
  if (size.value === 'large') return 'badge-square__text__large'
  if (size.value === 'extra-small') return 'badge-square__text__extra-small'
  else return ''
})
const badgeClassesIcon = computed(() => {
  if (size.value === 'extra-small') {
    return 'badge-square__icon__extra-small'
  } else return 'badge-square__icon'
})
const customColorProp = computed(() => props.customColor)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge-square", {
      'badge-square--primary': _ctx.primary,
      'badge-square--secondary': _ctx.secondary,
      'badge-square--custom-color': customColorProp.value,
      'badge-square--grey': _ctx.grey,
      'badge-square__small': _unref(size) === 'small',
      'badge-square__medium': _unref(size) === 'medium',
      'badge-square__large': _unref(size) === 'large',
      'badge-square__extra-small': _unref(size) === 'extra-small'
    }]),
    style: _normalizeStyle(_ctx.containerStyle),
    tabindex: _ctx.tabIndex
  }, [
    (_ctx.hasLeftIcon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SvgDisplay, {
            src: "Icon-X-Small",
            class: _normalizeClass(badgeClassesIcon.value)
          }, null, 8, ["class"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(TextBase, {
      class: _normalizeClass(badgeClassesText.value),
      text: _unref(badgeText),
      type: "label",
      color: "inherit",
      "text-wrap": "wrap",
      "overflow-tooltip": ""
    }, null, 8, ["class", "text"]),
    (_ctx.hasRightIcon)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(badgeClassesIcon.value)
        }, [
          _createVNode(SvgDisplay, {
            src: "Icon-X-Small",
            class: _normalizeClass(badgeClassesIcon.value)
          }, null, 8, ["class"])
        ], 2))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})